module.exports = __webpack_public_path__ + "static/img/player_02_program.8e2906e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_02_program.svg
// module id = otZt
// module chunks = 0